import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styled, { withTheme } from 'styled-components';
import { defaultTheme } from '../../constants/appConfig';
import newid from '../../utils/newid';

const StyledUiCheckbox = styled.div`
  label {
    &:after {
      border-bottom: 2px solid ${props => (props.theme ? props.theme.primaryBgColor : defaultTheme.primaryBgColor)};
      border-left: 2px solid ${props => (props.theme ? props.theme.primaryBgColor : defaultTheme.primaryBgColor)};
    }
  }
`;

class Checkbox extends React.PureComponent {
  static propTypes = {
    value: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    theme: PropTypes.object,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    disabled: false,
    theme: {},
  };

  constructor(props) {
    super(props);

    this.id = newid();

    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.props.onChange(e.target.checked);
  }

  render() {
    const className = classnames(`ui-checkbox ${this.props.theme.inputStyle}`, {
      disabled: this.props.disabled,
    });

    return (
      <StyledUiCheckbox className={className}>
        <div className="checkbox-wrap">
          <input
            type="checkbox"
            id={this.id}
            checked={this.props.value}
            disabled={this.props.disabled}
            onChange={this.onChange}
          />
          <label htmlFor={this.id}>
            <span className="label-text" dangerouslySetInnerHTML={{ __html: this.props.label }} />
          </label>
        </div>
      </StyledUiCheckbox>
    );
  }
}

export default withTheme(Checkbox);
